import React, { useEffect, useState } from 'react'
import Header from '../header'
import { CategoryBox, ImgWrapper, ItemWrapper, ListWrapper, Wrapper } from './styles'
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Card, DatePicker, Empty, FloatButton, Image, Select, Typography } from 'antd';
import mechanic from "../../../assets/icons/mechanic.png"
import gear from "../../../assets/icons/gear.png"
import expense from "../../../assets/icons/expense.png"
import { financeIcon } from '../../../constants/finance';
import { thousandSeparator } from '../../../utils/numberManager';
import dayjs from 'dayjs';
import { useFinanceReport } from '../../../zustand/store';
import { PlusOutlined } from '@ant-design/icons';
import { BASE_URL } from '../../../constants/link';
import { CalendarPicker } from 'antd-mobile';

const expenseImg = {
  part: gear,
  //   repairer: "linear-gradient( 135deg, #E2B0FF 10%, #9F44D3 100%)",
  mechanic,
  default: expense,
};

const Img = ({ src, category }) => {
  return (
    <ImgWrapper category={category}>
      {src ? <Image src={src} alt="images" /> : <img src={expenseImg[category] || expenseImg.default} alt={category} />}
    </ImgWrapper>
  )
}

const FinanceItem = ({
  // name, year, expense, img, category, id: eId 
  addedAt, carId, category, color
  , createdAt,
  debt,
  id: eId,
  image,
  imageId,
  images,
  name,
  note,
  price,
  thumbnailId,
  type,
  updatedAt,
  car

}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return <ItemWrapper onClick={() => {

    if (carId) {
      navigate(`/car/${carId}/expense/${eId}?from=finance`)
    } else {
      navigate(`/finance/${eId}`)
    }


  }} >
    <Img
      src={financeIcon(category) || financeIcon("Other")}
      alt={category}
      category={
        category
      }
    />
    <div className='data'>
      <div>
        <Typography.Text strong>
          {category === "Sold" ? "Sold Out" : category}
        </Typography.Text>
      </div>
      <div>
        <Typography.Text>{note}

        </Typography.Text>
      </div>
      {/* <div>
              <Typography.Text type="secondary">{year}</Typography.Text>
          </div> */}
    </div>
    <div className='rightside'>
      {/* <div className='expense'> */}
      {type === "expense" ?
        <Typography.Text small style={{ textAlign: "right" }} strong align="right"
          type='danger'
        >

          -${thousandSeparator(price)}
        </Typography.Text>

        :
        type === "income" ?
          <Typography.Text small style={{ textAlign: "right" }} strong align="right"
            type='success'
          >

            ${thousandSeparator(price)}
          </Typography.Text> : <Typography.Text small style={{ textAlign: "right" }} strong align="right"
          >

            ${thousandSeparator(price)}
          </Typography.Text>
      }
      <Typography.Text type="secondary">
        <small>
          {dayjs(addedAt).format("DD/MM/YYYY")}
        </small>
      </Typography.Text>
      {/* </div> */}
    </div>
    {!!images.length &&
      <>
        <div style={{ width: "100%", borderTop: "1px solid black" }} />
        <div style={{
          // border: "1px solid black",
          display: "flex", width: "100%", gap: "10px"
        }}>
          {images?.map(({ img, photo, main }, i) => (
            <div
              key={i}

              size='small'>
              <Image width={"auto"} style={{ objectFit: "contain", objectPosition: "center" }} height={"70px"} src={
                `${BASE_URL}/file/${photo?.[photo.length - 1]?.file_id}`
              } />
              {!photo.length && <Alert type="error" message={"ERROR"} />}
            </div>
          ))}
        </div>
      </>
    }
    {!!car && <>
      <div style={{ width: "100%", borderTop: "1px solid black" }} />
      <div style={{ display: "flex", gap: "10px" }}>
        <Typography.Text strong>{car?.make}/{car?.model}</Typography.Text>
        <Typography.Text >{car?.year}</Typography.Text>
        <Typography.Text >{((car?.mileage || 0) / 1000).toFixed(1)}K</Typography.Text>
        <Typography.Text >{car?.color}</Typography.Text>
      </div>
    </>
    }
  </ItemWrapper>
}

const ReportData = () => {

  const financeReport = useFinanceReport();


  const total = financeReport?.data?.reduce((t, v, i) => ({
    ...t,
    [v.category]: {
      ...t[v.category],
      [v.type]: (t?.[v.category]?.[v.type] || 0) + (v?.price || 0)
    }
  }), {})

  const totalIE = financeReport?.data?.reduce((t, v, i) => ({
    ...t,
    [v.type]: v.price + (t[v.type] || 0)
    // {
    //   ...t[v.category],
    //   [v.type]: (t?.[v.category]?.[v.type] || 0) + (v?.price || 0)
    // }
  }), {})

  const fontSize = "25px";
  return <div>
    <div style={{ margin: "15px auto", width: "fit-content" }}>
      <Card size='small' style={{ width: "fit-content", border: "1px solid black" }}>
        <div style={{
          display: "flex",
          // flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          // margin: "0px auto", 
          width: "fit-content"
        }}>
          {totalIE?.income && <div>
            <Typography.Text style={{ fontSize }} strong type='success'>
              ${thousandSeparator(totalIE?.income || 0)}
            </Typography.Text>
          </div>}
          <div>
            <Typography.Text style={{ fontSize }} strong type='danger'>
              -${thousandSeparator(totalIE?.expense || 0)}
            </Typography.Text>
          </div>
        </div>

        {totalIE?.income && totalIE?.expense &&
          <>
            <div style={{ width: "100%", borderTop: "1px solid black" }} />
            <div
              style={{
                display: "flex",
                // flexDirection: "column",
                alignItems: "center",
                gap: "0px",
                margin: "0px auto",
                width: "fit-content"
              }}
            >

              <Typography.Text style={{ fontSize }} strong
              // type='success'
              >
                {(totalIE?.income || 0) - (totalIE?.expense || 0) < 0 && "-"}${thousandSeparator(Math.abs((totalIE?.income || 0) - (totalIE?.expense || 0)))}
              </Typography.Text>
            </div>
          </>
        }
      </Card>

    </div>
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", margin: "auto", width: "fit-content" }}>
      {Object.entries(total || {}).map(([key, value]) => (
        <CategoryBox style={{ width: "fit-content" }}>
          <div style={{ position: "relative" }}>
            <img src={financeIcon(key)} alt="" />
          </div>
          <div className='price'>
            {value?.expense && <div>
              <Typography.Text strong type='danger'>
                -${thousandSeparator(value?.expense || 0)}
              </Typography.Text>
            </div>}
            {value?.income && <div>
              <Typography.Text strong type='success'>
                ${thousandSeparator(value?.income || 0)}
              </Typography.Text>
            </div>}

          </div>
          {/* <div>
          {key}:
          {value?.income || 0} {value?.expense || 0}
        </div> */}
        </CategoryBox>
      ))}
    </div>
  </div>
}

const RangeSection = ({ date, setDate }) => {


  const [visible, setVisible] = useState(false);

  return <div style={{ width: "100%", }}>
    {/* <DatePicker.RangePicker
      value={date}
      style={{ width: "100%" }} onChange={(e) => {
        console.log(e);
        setDate(e)
      }} /> */}
    <Card size='small' style={{ border: "1px solid black", width: "100%", textAlign: "center" }}
      onClick={() => {
        setVisible(true)
      }}
    >
      <Typography.Text strong>
        {date[0].format("DD MMM YY")} - {date[1].format("DD MMM YY")}
      </Typography.Text>
    </Card>
    <CalendarPicker
      min={dayjs().subtract(1, "years").startOf("year")}
      max={dayjs().endOf("month")}
      visible={visible}
      selectionMode='range'
      weekStartsOn='Monday'
      defaultValue={date}
      onClose={() => {
        setVisible(false)
      }}
      onMaskClick={() => {
        setVisible(false)
      }}
      onConfirm={([start, end]) => {
        // console.log(val);
        setDate([dayjs(start).startOf("day"), dayjs(end).endOf("day")])
      }}
    // onChange={val => {
    //   console.log(val);

    //   // setDate(val)
    // }}
    />
    {/* <Select style={{ width: "200px" }} /> */}
  </div>
}

function FinancePage() {
  const [date, setDate] = useState(
    [dayjs().startOf("month"), dayjs().endOf("month")]
  );
  const financeReport = useFinanceReport();
  const navigate = useNavigate();

  useEffect(() => {
    financeReport.execute({
      params: {
        from: date[0],
        to: date[1]
      }, force: true
    });
  }, [date])

  return (
    <Wrapper>
      {/* <Header title="Finance" /> */}
      <RangeSection date={date} setDate={setDate} />
      <ReportData />
      {
        financeReport.success && !financeReport.data?.length ?
          <div style={{ height: "calc(100vh - 300px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Empty />
          </div> :
          <ListWrapper>
            {financeReport.data?.map((v, i) => (
              <>
                <FinanceItem key={i} {...v} />
              </>
            ))}
          </ListWrapper>}
      <FloatButton type='primary' icon={<PlusOutlined />}
        onClick={() => navigate("/finance/new")}
      />
    </Wrapper>
  )
}

export default FinancePage